export const ADMIN_WEB_PAGES_URLS = {
  consultations: {
    onlineList: 'consultations/online',
    phoneList: 'consultations/phone',
    generalList: 'consultations/general'
  },
  requisitions: {
    allList: 'requisitions',
    single: 'requisitions/:id'
  },
  users: {
    schedule: 'users/schedule'
  },
  login: 'login',
  labReq: 'lab-req',
  sessionReport: 'session-report/:id',
  customers: {
    allList: 'customers',
    byId: 'customers/:id'
  },
  tasks: {
    list: 'tasks'
  },
  prescriptions: {
    allList: 'prescriptions',
    pdf: 'prescriptions/:id/pdf'
  },
  orders: {
    allList: 'orders',
    kanban: 'kanban',
    single: 'orders/:id'
  },
  appointments: {
    allList: 'appointments',
    myList: 'my-appointments',
    calendar: 'appointments/calendar'
  },
  encounter: {
    current: 'encounter',
    single: 'encounter/:id'
  },
  session: {
    current: 'session',
    single: 'session/:id'
  },
  subscriptions: {
    allList: 'subscriptions'
  },
  drugs: {
    allList: 'drugs'
  },
  labResults: {
    allList: 'lab-results'
  }
};
Object.freeze(ADMIN_WEB_PAGES_URLS);
